<template>
  <a
    ref="btnRef"
    role="button"
    @click="onClick"
  >
    <slot></slot>
  </a>
</template>

<script>
import { ref, onMounted, markRaw, onUnmounted, onActivated, onDeactivated } from 'vue'
import Store from 'store'
import tippy from 'tippy.js'

export default {
  name: 'TippyBounceButton',
  props: {
    storeKey: {
      type: String,
      require: true
    },
    tippyContent: {
      type: String,
      require: true
    },
    tippyOptions: {
      type: Object
    }
  },
  emits: ['click'],
  setup (props, { emit }) {
    const btnRef = ref(null)
    const tippyInstance = ref(null)

    onMounted(() => {
      const isClicked = Store.get(props.storeKey)

      if (!isClicked) {
        tippyInstance.value = markRaw(tippy(btnRef.value, {
          content: props.tippyContent,
          showOnCreate: true,
          hideOnClick: false,
          trigger: 'manual',
          onMount (instance) {
            instance.popper.firstElementChild.classList.add('animation-shake')
          },
          ...props.tippyOptions
        }))
      }
    })

    onUnmounted(() => {
      if (tippyInstance.value) {
        tippyInstance.value.destroy()
      }
    })

    onDeactivated(() => {
      if (tippyInstance.value) {
        tippyInstance.value.hide()
      }
    })

    onActivated(() => {
      if (tippyInstance.value) {
        tippyInstance.value.show()
      }
    })

    const onClick = () => {
      if (tippyInstance.value) {
        tippyInstance.value.hide()
        Store.set(props.storeKey, true)
      }

      emit('click')
    }

    return {
      btnRef,
      onClick
    }
  }
}
</script>
